import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import CaregiverCashPage from '@pages/caregiverCash/CaregiverCashPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// Route Component
const CaregiverCashRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('caregiver-cash-page-title')}>
        <CaregiverCashPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  CaregiverCashRoute,
};
